/* Seasonal bonus with a persistent optional visitor window. This local preview never writes a cart or sends an order. */
(function () {
  'use strict';
  const DEFAULT_DEADLINE = '2026-11-28T00:00:00-05:00';

  function getBonusState(nowMs, deadline = DEFAULT_DEADLINE, baseQuantity = 3) {
    const endMs = Date.parse(deadline);
    const quantity = Number.isInteger(baseQuantity) && baseQuantity >= 0 ? baseQuantity : 0;
    const active = Number.isFinite(nowMs) && Number.isFinite(endMs) && nowMs < endMs;
    const remainingSeconds = active ? Math.ceil((endMs - nowMs) / 1000) : 0;
    return {
      active,
      remainingSeconds,
      days: Math.floor(remainingSeconds / 86400),
      hours: Math.floor(remainingSeconds % 86400 / 3600),
      minutes: Math.floor(remainingSeconds % 3600 / 60),
      seconds: remainingSeconds % 60,
      bonusQuantity: active ? 1 : 0,
      totalQuantity: quantity + (active ? 1 : 0)
    };
  }

  function getVisitorDeadline(nowMs, campaignDeadline, durationHours, storage, key) {
    const campaignEnd = Date.parse(campaignDeadline);
    const duration = Number(durationHours) * 3600000;
    if (!Number.isFinite(campaignEnd) || !Number.isFinite(nowMs) || !(duration > 0)) return campaignDeadline;
    try {
      const saved = storage.getItem(key);
      const savedEnd = saved === null ? NaN : Number(saved);
      // Retain expired timestamps; revisiting never restarts the offer.
      const end = Number.isFinite(savedEnd) && savedEnd > 0
        ? Math.min(savedEnd, campaignEnd)
        : Math.min(nowMs + duration, campaignEnd);
      storage.setItem(key, String(end));
      return new Date(end).toISOString();
    } catch (_) {
      // Without persistent storage, do not promise a restarting visitor offer.
      return new Date(Math.min(nowMs, campaignEnd)).toISOString();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { DEFAULT_DEADLINE, getBonusState, getVisitorDeadline };
  }
  if (typeof document === 'undefined') return;
  const root = document.getElementById('mv-bonus-offer');
  if (!root) return;
  const bonusInput = document.getElementById('mv-bonus-input');
    const summary = document.querySelector('[data-bonus-summary]');
  const clock = document.querySelector('.mv-bonus-clock');
  const expired = root.querySelector('.mv-bonus-expired');
  let intervalId;
  let deadline = root.dataset.bonusEnd || DEFAULT_DEADLINE;
  if (root.dataset.bonusHours) {
    let storage;
    try { storage = window.localStorage; } catch (_) { /* Fail closed below. */ }
    deadline = getVisitorDeadline(Date.now(), deadline, root.dataset.bonusHours,
      storage, 'meravae:halloween:2026:bonus-deadline');
  }

  function getCurrentState() {
    const choice = document.querySelector('#mv-bundles input[name="id"]:checked');
    const bundle = choice && choice.closest('.mv-bundle');
    const baseQuantity = bundle ? bundle.querySelectorAll('.mv-b-thumb img').length : 0;
    return { ...getBonusState(Date.now(), deadline, baseQuantity), baseQuantity };
  }

  function render() {
    const state = getCurrentState();
    root.hidden = false;
    root.classList.toggle('is-expired', !state.active);
    document.body.dataset.bonusState = state.active ? 'active' : 'expired';
    document.querySelectorAll('[data-bonus-active]').forEach(el => { el.hidden = !state.active; });
    document.querySelectorAll('[data-bonus-ended]').forEach(el => { el.hidden = state.active; });
    for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
      const digit = document.querySelector('[data-bonus-' + unit + ']');
      if (digit) digit.textContent = String(state[unit]).padStart(2, '0');
    }
    clock.setAttribute('aria-label', state.active
      ? `${state.days ? state.days + ' days, ' : ''}${state.hours} hours, ${state.minutes} minutes and ${state.seconds} seconds left for your free bonus tube`
      : 'The free bonus tube offer has ended');
    summary.textContent = state.active
      ? `${state.totalQuantity} tubes in your order: ${state.baseQuantity} in your bundle + 1 free bonus.`
      : `${state.baseQuantity} tubes in your bundle.`;
    bonusInput.value = String(state.bonusQuantity);
    bonusInput.disabled = !state.active;
    expired.hidden = state.active;
    if (window.MeravaeGiftSavings) window.MeravaeGiftSavings(state);
    if (!state.active && intervalId) clearInterval(intervalId);
    return state;
  }

  window.MeravaeSeasonalBonus = { DEFAULT_DEADLINE, getBonusState, getCurrentState, refresh: render };
  document.querySelectorAll('#mv-bundles input[name="id"]').forEach(input => input.addEventListener('change', render));
  document.addEventListener('visibilitychange', render);
  window.addEventListener('pageshow', render);
  window.addEventListener('focus', render);
  if (render().active) intervalId = setInterval(render, 1000);
})();
